module.exports = __webpack_public_path__ + "img/map_place.2b7c48a7.svg";